export default __webpack_public_path__ + "public/images/fa-eye-slash.svg";